import React from "react";

// Shared loading-state building blocks for the admin list pages (programs,
// articles, leads) -- keeps the page's real layout (summary cards, table
// shell) mounted at its final size while data loads, instead of swapping in
// a tiny "加载中…" line that then jumps to the full table once data arrives.

// Gray pulsing bar standing in for a cell's real content while loading.
export function Bone({ width }: { width: string }) {
  return <div className={`h-4 ${width} bg-c-gray rounded animate-pulse`} />;
}

export function SummaryCard({ label, value }: { label: string; value: number | null }) {
  return (
    <div className="bg-white rounded-xl border border-fourth-light px-5 py-4">
      {value === null ? (
        <div className="h-8 w-12 bg-c-gray rounded animate-pulse" />
      ) : (
        <p className="text-2xl font-semibold text-secondary-dark">{value}</p>
      )}
      <p className="text-xs text-secondary-light mt-1">{label}</p>
    </div>
  );
}

// One skeleton table row -- pass the same cell count/widths as the real
// rows so the table's column proportions don't shift once data loads.
export function SkeletonRow({ widths }: { widths: string[] }) {
  return (
    <tr className="border-t border-fourth-light">
      {widths.map((width, i) => (
        <td key={i} className="px-4 py-3">
          <Bone width={width} />
        </td>
      ))}
    </tr>
  );
}
